import {
    Button,
    ButtonIcon,
    ButtonText,
    Check,
    Confirm,
    Flexer,
    Heading,
    Icon,
    If,
    Input,
    Modal,
    Notification,
    NotificationText,
    Panel,
    ScrollView,
    Text,
    Textarea,
    View,
} from '@adtriba/ui'
import { useAuth0 } from '@auth0/auth0-react'
import dayjs from 'dayjs'
import React, { FunctionComponent, ReactElement, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { LoaderComponent } from '../../../../components/loader/loader.component'
import { NotificationComponent } from '../../../../components/notification/notification.component'
import { COLOR, DATE_FORMAT_METRIC, ERROR, INTEGRATIONS, POSITION } from '../../../../constants'
import { AppContext } from '../../../../contexts/app.context'
import { groupBy, logError } from '../../../../helpers/util'
import { IntegrationsService } from '../../services/integrations.service'
import './integrations.component.sass'
import process from 'process'

declare global {
    interface Window {
        authPopup: any
    }
}

const GoogleAdsTextLogo = ({ size }) => {
    return (
        <svg
            height={size * 60}
            width={size * 120}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <clipPath id="a">
                <path d="m0 0h250.9v312.8h-250.9z" />
            </clipPath>
            <g clipPath="url(#a)" transform="matrix(.176308 0 0 .176308 7.367521 8.916185)">
                <path
                    d="m85.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54l51.6 89.8c14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21l-45.4-78.8c-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9l-33.4-57.9c-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6"
                    fill="#3c8bd9"
                />
                <path
                    d="m85.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5l32.9 56.9c1 1.7 1.8 3.4 2.8 5l-18.1 31.1-25.3 43.6c-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5l14.3-24.9 59.5-103.1c.2-.4.5-.7.7-1.1"
                    fill="#fabc04"
                />
                <path
                    d="m11.8 158 5.7-5.1c24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9-19.7-1.4-35.2-16.2-37.9-35.8-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2"
                    fill="#34a852"
                />
                <path d="m11.8 158c-.4.4-.4 1.1-1.1 1.2-.1-.7.3-1.1.7-1.6z" fill="#fabc04" />
                <path d="m81.6 201c-.4-.7 0-1.2.4-1.7l.4.4z" fill="#e1c025" />
            </g>

            <g fill="#757575">
                <path
                    clipPath="url(#a)"
                    d="m20.7 260.4c-11.3 0-20.7 9.1-20.7 20.3s9.4 20.2 20.7 20.2c6.1 0 10.6-2 14.2-5.7 3.7-3.7 4.8-8.8 4.8-12.9 0-1.3-.1-2.5-.3-3.5h-18.7v5.5h13.3c-.4 3.1-1.4 5.4-3 7-1.9 1.9-5 4.1-10.3 4.1-8.2 0-14.6-6.6-14.6-14.7s6.4-14.7 14.6-14.7c4.4 0 7.7 1.7 10 4l3.9-3.9c-3.3-3.2-7.7-5.7-13.9-5.7zm33.9 14.5c-7.1 0-13 5.5-13 13.2 0 7.6 5.8 13.2 13 13.2s13-5.6 13-13.2-5.9-13.2-13-13.2m0 21.2c-3.9 0-7.3-3.3-7.3-8s3.4-8 7.3-8 7.3 3.2 7.3 8c0 4.7-3.4 8-7.3 8m28.2-21.2c-7.2 0-13 5.5-13 13.2 0 7.6 5.8 13.2 13 13.2 7.1 0 13-5.6 13-13.2s-5.8-13.2-13-13.2m0 21.2c-3.9 0-7.3-3.3-7.3-8s3.4-8 7.3-8 7.3 3.2 7.3 8c0 4.7-3.3 8-7.3 8m28.1-21.2c-6.5 0-12.4 5.7-12.4 13.1 0 7.3 5.9 13 12.4 13 3.1 0 5.5-1.4 6.8-3h.2v1.9c0 5-2.6 7.7-6.9 7.7-3.5 0-5.6-2.5-6.5-4.6l-5 2.1c1.4 3.5 5.2 7.7 11.5 7.7 6.7 0 12.3-4 12.3-13.6v-23.4h-5.4v2.1h-.2c-1.3-1.6-3.7-3-6.8-3m.5 21c-3.9 0-7.2-3.3-7.2-7.9s3.3-8 7.2-8 6.9 3.4 6.9 8-3 7.9-6.9 7.9m16.1-33.9h5.7v38.6h-5.7zm21 12.9c-6.8 0-12.5 5.3-12.5 13.2 0 7.4 5.6 13.2 13.1 13.2 6.1 0 9.6-3.7 11-5.8l-4.5-3c-1.5 2.2-3.6 3.6-6.5 3.6-3 0-5.1-1.3-6.4-4l17.7-7.3-.6-1.5c-1.1-2.9-4.5-8.4-11.3-8.4m-6.8 12.8c-.2-5.1 4-7.7 6.9-7.7 2.3 0 4.3 1.1 4.9 2.8z"
                    transform="matrix(.400583 0 0 .400583 50.118826 -91.811827)"
                />
                <path
                    clipPath="url(#a)"
                    d="m170.4 300 13.2-35.1h5.1l13.2 35.1h-5l-3.4-9.5h-14.7l-3.4 9.5zm9.9-13.7h11.7l-5.7-15.8h-.2zm26.2 10.8c-2.2-2.5-3.3-5.5-3.3-9.1 0-3.5 1.1-6.5 3.3-9.1 2.3-2.5 4.9-3.7 8.1-3.7 1.8 0 3.4.4 4.8 1.1 1.5.8 2.6 1.7 3.4 3h.2l-.2-3.3v-11.1h4.5v35.1h-4.3v-3.3h-.2c-.8 1.2-1.9 2.2-3.4 3s-3.1 1.1-4.8 1.1c-3.2 0-5.9-1.2-8.1-3.7m14.2-2.8c1.5-1.6 2.2-3.7 2.2-6.3 0-2.5-.7-4.6-2.2-6.2-1.4-1.6-3.2-2.4-5.4-2.4s-4 .8-5.4 2.4c-1.5 1.6-2.2 3.7-2.2 6.2s.7 4.6 2.2 6.2 3.3 2.4 5.4 2.4c2.2.1 4-.7 5.4-2.3m27.4 4.3c-1.8 1.4-4.1 2.2-6.9 2.2-2.4 0-4.5-.6-6.4-1.9-1.8-1.3-3.1-2.9-3.9-5l4-1.7c.6 1.4 1.4 2.6 2.6 3.4 1.1.8 2.4 1.2 3.7 1.2 1.4 0 2.6-.3 3.6-.9s1.4-1.4 1.4-2.2c0-1.5-1.2-2.7-3.5-3.4l-4.1-1c-4.7-1.2-7-3.4-7-6.8 0-2.2.9-3.9 2.7-5.3 1.8-1.3 4.1-2 6.8-2a11.66 11.66 0 0 1 5.8 1.5c1.7 1 2.9 2.4 3.6 4.1l-4 1.7c-.5-1-1.2-1.8-2.2-2.4s-2.2-.9-3.5-.9c-1.2 0-2.2.3-3.2.9-.9.6-1.4 1.3-1.4 2.2 0 1.4 1.3 2.4 3.9 2.9l3.6.9c4.8 1.2 7.1 3.6 7.1 7.2.1 2.1-.9 3.9-2.7 5.3"
                    transform="matrix(.400583 0 0 .400583 -3.073802 -72.995397)"
                />
            </g>
        </svg>
    )
}

const GoogleAdsIconLogo = ({ size }) => {
    return (
        <svg
            height={size * 60}
            width={size * 60}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <clipPath id="a">
                <path d="m0 0h250.9v312.8h-250.9z" />
            </clipPath>
            <g clipPath="url(#a)" transform="matrix(.176308 0 0 .176308 7.367521 8.916185)">
                <path
                    d="m85.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54l51.6 89.8c14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21l-45.4-78.8c-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9l-33.4-57.9c-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6"
                    fill="#3c8bd9"
                />
                <path
                    d="m85.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5l32.9 56.9c1 1.7 1.8 3.4 2.8 5l-18.1 31.1-25.3 43.6c-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5l14.3-24.9 59.5-103.1c.2-.4.5-.7.7-1.1"
                    fill="#fabc04"
                />
                <path
                    d="m11.8 158 5.7-5.1c24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9-19.7-1.4-35.2-16.2-37.9-35.8-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2"
                    fill="#34a852"
                />
                <path d="m11.8 158c-.4.4-.4 1.1-1.1 1.2-.1-.7.3-1.1.7-1.6z" fill="#fabc04" />
                <path d="m81.6 201c-.4-.7 0-1.2.4-1.7l.4.4z" fill="#e1c025" />
            </g>
        </svg>
    )
}

const FacebookIconLogo = ({ size }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size * 60}
            width={size * 60}
            viewBox="-204.79995 -341.33325 1774.9329 2047.9995"
        >
            <path
                d="M1365.333 682.667C1365.333 305.64 1059.693 0 682.667 0 305.64 0 0 305.64 0 682.667c0 340.738 249.641 623.16 576 674.373V880H402.667V682.667H576v-150.4c0-171.094 101.917-265.6 257.853-265.6 74.69 0 152.814 13.333 152.814 13.333v168h-86.083c-84.804 0-111.25 52.623-111.25 106.61v128.057h189.333L948.4 880H789.333v477.04c326.359-51.213 576-333.635 576-674.373"
                fill="#1877f2"
            />
            <path
                d="M948.4 880l30.267-197.333H789.333V554.609C789.333 500.623 815.78 448 900.584 448h86.083V280s-78.124-13.333-152.814-13.333c-155.936 0-257.853 94.506-257.853 265.6v150.4H402.667V880H576v477.04a687.805 687.805 0 00106.667 8.293c36.288 0 71.91-2.84 106.666-8.293V880H948.4"
                fill="#fff"
            />
        </svg>
    )
}

const FacebookTextLogo = ({ size }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={size * 60}
            width={size * 120}
            viewBox="-150 -48.38625 1300 290.3175"
        >
            <path
                d="M63.35 190.562H25.669V96.628H0V66.045h25.668V44.283C25.668 18.495 37.021 0 74.6 0c7.948 0 20.426 1.602 20.426 1.602V30H81.92c-13.354 0-18.568 4.062-18.568 15.292v20.753h31.174L91.75 96.628H63.351zm86.46-126.961c-.549 0-1.114.02-1.673.034-34.94 0-50.926 26.282-50.926 63.59 0 46.998 20.736 65.808 51.199 65.808 17.429 0 28.88-7.336 35.84-21.026v18.568h35.84V66.058h-35.84v19.149c-5.683-12.32-17.454-21.46-34.44-21.606zm9.113 29.423c14.675 0 23.483 10.236 23.483 27.647l.034 17.783c0 11.735-7.275 25.464-23.517 25.464-24.97 0-24.303-26.962-24.303-35.942 0-30.207 13.304-34.952 24.303-34.952zm75.641 35.299c0-15.131-.724-64.641 63.78-64.641 25.893 0 36.705 8.233 36.705 8.233l-8.69 26.953s-10.798-5.946-24.868-5.946c-18.021 0-29.52 10.447-29.52 28.828l.02 13.18c0 17.662 11.095 29.452 29.537 29.452 12.818 0 24.632-6.002 24.632-6.002l8.668 26.39s-9.886 8.285-36.303 8.285c-61.418 0-63.96-44.42-63.96-64.732zm310.628-64.688c34.941 0 51.179 26.282 51.179 63.59 0 46.998-20.737 65.808-51.2 65.808-17.429 0-30.313-7.335-37.273-21.026v18.568l-35.389-.014V3.786L510.083.509V83.52c5.423-14.523 23.245-19.885 35.11-19.885zm-10.534 29.389c-14.675 0-24.575 10.236-24.575 27.647l-.035 17.783c-.022 11.735 6.856 25.464 24.61 25.464 24.97 0 24.303-26.962 24.303-35.942 0-30.207-13.303-34.952-24.303-34.952zM400.243 63.738c-39.63 0-60.552 21.607-60.552 60.005v7.134c0 49.837 29.381 62.668 64.409 62.668 34.047 0 49.458-9.523 49.458-9.523l-7.031-25.36s-18.128 7.713-37.922 7.713c-20.52 0-29.345-5.23-31.607-24.95h79.564V121.08c0-41.652-23.481-57.343-56.32-57.343zm.955 25.394c13.718 0 22.607 8.412 22.119 27.921h-46.25c.802-20.533 10.388-27.92 24.131-27.92zm270.094-25.565c-40.697 0-62.122 22.934-62.122 64.033 0 56.39 36.932 65.467 62.19 65.467 36.976 0 61.576-19.907 61.576-64.955 0-46.887-27.66-64.545-61.644-64.545zm-.512 29.559c17.895 0 24.986 13.393 24.986 28.638v13.107c0 18.468-9.922 29.15-25.054 29.15-14.152 0-24.098-9.992-24.098-29.15v-13.107c0-20.432 11.835-28.638 24.166-28.638zm137.01-29.559c-40.697 0-62.122 22.934-62.122 64.033 0 56.39 36.932 65.467 62.19 65.467 36.975 0 61.576-19.907 61.576-64.955 0-46.887-27.661-64.545-61.644-64.545zm-.512 29.559c17.895 0 24.985 13.393 24.985 28.638v13.107c0 18.468-9.922 29.15-25.053 29.15-14.152 0-24.098-9.992-24.098-29.15v-13.107c0-20.432 11.835-28.638 24.166-28.638zm76.355 97.436V3.786L921.316.51v125.189l37.386-59.653h39.796l-39 61.783L1000 190.562h-39.909l-38.775-60.914v60.914z"
                fill="#1877f2"
            />
        </svg>
    )
}

const FacebookIntegrationPixelId = (props: any) => {
    return (
        <View row justify="flex-start" class="mt-200" height={30}>
            <View flex={2} row justify="flex-start">
                <Text class="fw-500 cl-gray-500">Pixel ID: {props.pixelId}</Text>
            </View>
            <View flex={2} row justify="flex-end">
                <Button small onClick={props.onDelete}>
                    <ButtonText>Remove</ButtonText>
                </Button>
            </View>
        </View>
    )
}

const Integration = (props: any) => {
    useEffect(() => {}, [])

    return (
        <View row justify="flex-start" class="mt-600 mb-600">
            <View width={60}>
                <GoogleAdsIconLogo size={1} />
            </View>
            <View flex={2} class="pl-800">
                <Heading>{props.name}</Heading>
                <View row justify="flex-start" width="fit-content">
                    <View>
                        <If if={props.statusMessage}>
                            <Text class="fw-500 cl-gray-500">Connection Status: {props.statusMessage}</Text>
                        </If>
                        <Text class="fw-500 cl-gray-500">Customer ID: {props.customerId}</Text>
                        <If if={props.googleAccount}>
                            <Text class="fw-500 cl-gray-500">Google account: {props.googleAccount}</Text>
                        </If>
                        <Text class="fw-500 cl-gray-500">
                            {props.timezone} - {props.currency}
                        </Text>
                    </View>
                </View>
            </View>
            <View flex={2} row justify="flex-end">
                <Button small light onClick={props.onUpdate} class="mr-200">
                    <ButtonText>Update</ButtonText>
                </Button>
                <Button small onClick={props.onRemove} class="mr-500">
                    <ButtonText>Remove</ButtonText>
                </Button>
            </View>
            <View flex={1} align="flex-start" class="pr-500" column>
                <View row justify="flex-start">
                    <Icon icon="time" size={14} color={COLOR.COLOR_GRAY_400} />
                    <If if={props.statusMessage == INTEGRATIONS.UNAUTHORIZED}>
                        <Text small class="pl-400 fw-700" style={{ marginRight: -7 }}>
                            Unhealthy since
                        </Text>
                    </If>
                    <Text small class="pl-400">
                        {dayjs(props.createdAt).format(DATE_FORMAT_METRIC)}
                    </Text>
                </View>
                <View row justify="flex-start" class="mt-100">
                    <Icon icon="email" size={14} color={COLOR.COLOR_GRAY_400} />
                    <Text small class="pl-400">
                        {props.email}
                    </Text>
                </View>
            </View>
        </View>
    )
}

const FacebookSettings = (props: any) => {
    const { getAccessTokenSilently } = useAuth0()
    const [accessToken, setAccessToken] = useState('')
    const [pixelIds, setPixelIds] = useState<string[]>([''])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)
    const [notification, setNotification] = useState(null)

    const validateInputs = (): boolean => {
        if (accessToken == '') {
            setNotification('Access token cannot be blank.')
            return false
        }

        if (pixelIds.findIndex((pixelId: string) => pixelId == '') != -1) {
            setNotification('Pixel ID values cannot be blank.')
            return false
        }

        return true
    }

    const handleSave = async () => {
        setNotification(null)

        if (validateInputs()) {
            setLoading(true)

            try {
                const token = await getAccessTokenSilently()
                const { accountId } = props

                // We don't need a response here
                await IntegrationsService.putIntegrationsFacebook(token, accountId, {
                    access_token: accessToken,
                    pixel_ids: pixelIds,
                })

                // Close the modal
                setLoading(false)
                props.onSave()
            } catch (e) {
                logError(e)
                setLoading(false)
                setError(e.message)
            }
        }
    }

    const deletePixelIdAtIndex = (index1: number) => {
        setPixelIds(pixelIds.filter((_: string, index2: number) => index1 != index2))
    }

    const updatePixelIdAtIndex = (pixelId1: string, index1: number) => {
        setPixelIds(
            pixelIds.map((pixelId2: string, index2: number) => {
                if (index1 == index2) return pixelId1
                return pixelId2
            })
        )
    }

    useEffect(() => {
        setAccessToken('')
        setPixelIds([''])
    }, [props.accountId])

    return (
        <Modal
            disableBackgroundDismiss
            width="500px"
            icon="copy"
            height="80%"
            position={POSITION.CENTER}
            borderRadius={20}
            onDismiss={props.onDismiss}
            footer={
                <View row justify="flex-end">
                    <Button light onClick={props.onDismiss}>
                        <ButtonText>Cancel</ButtonText>
                    </Button>
                    <Flexer />
                    <Button onClick={() => setPixelIds([...pixelIds, ''])} class="mr-200">
                        <ButtonText>Add pixel ID</ButtonText>
                    </Button>
                    <Button onClick={handleSave} disabled={accessToken == ''}>
                        <ButtonText>Save</ButtonText>
                    </Button>
                </View>
            }
        >
            <View width="100%" height="100%">
                <ScrollView>
                    <LoaderComponent loading={loading} />

                    <View class="p-900">
                        <NotificationComponent notification={notification} error={error} />

                        <View class="mb-900">
                            <Textarea
                                minHeight={150}
                                placeholder="Access Token"
                                label="Facebook Access Token"
                                value={accessToken}
                                onChange={(value) => setAccessToken(value.replace(/ /g, ''))}
                                onBlur={(value) => setAccessToken(value.replace(/ /g, ''))}
                            />
                        </View>

                        <Text class="cl-gray-500 t-uppercase mb-900 fw-700" small>
                            Pixel ID associated with this access token
                        </Text>

                        {pixelIds.map((pixelId: string, index: number) => (
                            <View class="mb-500" row key={index}>
                                <Input
                                    type="text"
                                    clear
                                    placeholder="Pixel ID"
                                    value={pixelId}
                                    onChange={(value) => updatePixelIdAtIndex(value.replace(/ /g, ''), index)}
                                    onBlur={(value) => updatePixelIdAtIndex(value.replace(/ /g, ''), index)}
                                />
                                <Button class="ml-400" onClick={() => deletePixelIdAtIndex(index)}>
                                    <ButtonIcon icon="minus" />
                                </Button>
                            </View>
                        ))}
                    </View>
                </ScrollView>
            </View>
        </Modal>
    )
}

const Settings = (props: any) => {
    const { getAccessTokenSilently } = useAuth0()
    const [accounts, setAccounts] = useState([])
    const [filter, setFilter] = useState('')
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)
    const [notification, setNotification] = useState(null)
    const [disabled, setDisabled] = useState(true)

    const isSelectAll = (accounts) => {
        let hasDisconnectedAccount = false

        const iterateOverAccounts = (accounts) => {
            accounts.map((account: any) => {
                if (!account.connected && !account.can_manage_clients) hasDisconnectedAccount = true
                if (account.child_accounts.length != 0) iterateOverAccounts(account.child_accounts)
            })
        }

        iterateOverAccounts(accounts)

        return !hasDisconnectedAccount
    }

    const selectAccounts = (accounts, select) => {
        setDisabled(false)
        return accounts.map((account: any) => {
            return {
                ...account,
                connected: select,
                child_accounts: selectAccounts(account.child_accounts, select),
            }
        })
    }

    const toggleChildrenAccountsSelected = (accounts, accountId, select) => {
        setDisabled(false)
        return accounts.map((account: any) => {
            if (accountId == account.id) {
                return {
                    ...account,
                    child_accounts: selectAccounts(account.child_accounts, select),
                }
            } else {
                return {
                    ...account,
                    child_accounts: toggleChildrenAccountsSelected(account.child_accounts, accountId, select),
                }
            }
        })
    }

    const toggleAccountsSelected = (accounts, accountId) => {
        setDisabled(false)
        return accounts.map((account: any) => {
            if (accountId != account.id) {
                if (account.child_accounts.length != 0) {
                    return {
                        ...account,
                        child_accounts: toggleAccountsSelected(account.child_accounts, accountId),
                    }
                } else {
                    return account
                }
            } else {
                return {
                    ...account,
                    connected: !account.connected,
                }
            }
        })
    }

    const handleActivateAccount = (accountId: any) => {
        setDisabled(false)
        setAccounts(toggleAccountsSelected([...accounts], accountId))
    }

    const handleSelectAccounts = (accountId: any, select: boolean) => {
        setDisabled(false)
        setAccounts(toggleChildrenAccountsSelected([...accounts], accountId, select))
    }

    const handleSave = async () => {
        setLoading(true)

        try {
            const token = await getAccessTokenSilently()
            const { tokenId, accountId } = props
            const add = []
            const remove = []

            // Get all of our additions / subtractions
            const iterateOverAccounts = (accounts) => {
                accounts.map((account: any) => {
                    if (account.connected && !account.can_manage_clients) add.push(account)
                    if (!account.connected && !account.can_manage_clients) remove.push(account)
                    if (account.child_accounts.length != 0) iterateOverAccounts(account.child_accounts)
                })
            }

            // Kick it off
            iterateOverAccounts(accounts)

            // We don't need a response here
            await IntegrationsService.putIntegrationsUpdate(
                token,
                accountId,
                {
                    to_add: add,
                    to_remove: remove,
                },
                { token: tokenId }
            )

            // Close the modal
            setLoading(false)
            props.onSave()
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
        }
    }

    const fetchData = async () => {
        setLoading(true)
        setDisabled(true)

        try {
            const token = await getAccessTokenSilently()
            const { tokenId, accountId } = props
            const result = await IntegrationsService.getIntegrationsGoogle(token, accountId, { token: tokenId })

            if (result.message == undefined) {
                setAccounts(result)
            } else {
                props.onError(result)
            }

            setLoading(false)
        } catch (e) {
            logError(e)
            props.onError(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        if (props.accountId) fetchData()
    }, [props.accountId])

    const renderAccounts = (accounts) => {
        return accounts
            .filter((account: any) => account.name.toLowerCase().includes(filter.toLowerCase()))
            .map((account: any, index: number) => {
                const selected = isSelectAll(account.child_accounts)

                return (
                    <View class="mb-500" key={index}>
                        <View row class="mb-200" justify="flex-start" key={index}>
                            <If if={!account.can_manage_clients}>
                                <Check
                                    onChange={() => handleActivateAccount(account.id)}
                                    checked={account.connected}
                                    disabled={false}
                                />
                            </If>

                            <If if={account.can_manage_clients}>
                                <View>
                                    <Icon icon="arrow-right" size={20} color={COLOR.COLOR_GRAY_700} />
                                </View>
                            </If>

                            <Text class="cl-gray-700 t-uppercase ml-300 fw-700" small>
                                {account.name + ' - ' + account.id}
                            </Text>

                            <Flexer />

                            <If if={account.child_accounts.length > 0}>
                                <View onClick={() => handleSelectAccounts(account.id, !selected)} class="buttonize">
                                    <Text class="cl-electric fw-900" small>
                                        {selected ? 'Select None' : 'Select All'}
                                    </Text>
                                </View>
                            </If>
                        </View>

                        <If if={account.child_accounts.length > 0}>
                            <View class="ml-900 mb-200">{renderAccounts(account.child_accounts || [])}</View>
                        </If>
                    </View>
                )
            })
    }

    return (
        <Modal
            disableBackgroundDismiss
            width="500px"
            icon="copy"
            height="80%"
            position={POSITION.CENTER}
            borderRadius={20}
            onDismiss={props.onDismiss}
            footer={
                <View row justify="flex-end">
                    <Button light onClick={props.onDismiss}>
                        <ButtonText>Cancel</ButtonText>
                    </Button>
                    <Flexer />
                    <Button onClick={handleSave} disabled={disabled}>
                        <ButtonText>Save</ButtonText>
                    </Button>
                </View>
            }
        >
            <View width="100%" height="100%">
                <ScrollView>
                    <LoaderComponent loading={loading} />
                    <NotificationComponent notification={notification} error={error} />

                    <View class="p-900">
                        <View class="mb-900">
                            <Input
                                type="text"
                                clear
                                placeholder="Filter"
                                value={filter}
                                onChange={(value) => setFilter(value)}
                                onBlur={(value) => setFilter(value)}
                            />
                        </View>

                        <Text class="cl-gray-500 t-uppercase mb-900 fw-700" small>
                            Please choose the accounts you would like to connect
                        </Text>

                        {renderAccounts(accounts)}
                    </View>
                </ScrollView>
            </View>
        </Modal>
    )
}

interface IIntegrationsComponent {
    children?: any
}

export const IntegrationsComponent: FunctionComponent = (props: IIntegrationsComponent): ReactElement => {
    const { getAccessTokenSilently, user } = useAuth0()
    const app = useContext(AppContext)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)
    const [notification, setNotification] = useState(null)
    const { accountId } = useParams()
    const [integrations, setIntegrations] = useState<any>([[]])
    const [facebookIntegrations, setFacebookIntegrations] = useState<any>([])
    const [settingsModal, setSettingsModal] = useState(false)
    const [facebookSettingsModal, setFacebookSettingsModal] = useState(false)
    const [status, setStatus] = useState(null)
    const [email, setEmail] = useState('')
    const [tokenId, setTokenId] = useState('')
    const [confirmModal, setConfirmModal] = useState(false)
    const [removeModal, setRemoveModal] = useState(false)
    const [removeFacebookModal, setFacebookRemoveModal] = useState(false)
    const [integrationId, setIntegrationId] = useState(null)

    const getRedirectUrl = (authToken: string) => {
        return `${process.env.REACT_APP_API_HOST}/integration/create-google-redirect-setup?authToken=${encodeURIComponent(authToken)}`
    }

    const handlePopupWindowOpen = async () => {
        setLoading(true)
        setError(null)

        try {
            const token = await getAccessTokenSilently()
            const authToken = await IntegrationsService.getGoogleRedirectAuthToken(token, accountId)
            const url = getRedirectUrl(authToken.token)

            setLoading(false)

            window.authPopup = window.open(
                url,
                'Complete OAuth2',
                'location=no,toolbar=no,menubar=no,width=600,height=500,left=200,top=100'
            )
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
        }
    }

    const closePopupWindow = () => {
        if (!window.authPopup) return

        window.authPopup.close()
        window.authPopup = null
    }

    const deleteIntegrationsGoogle = async () => {
        setLoading(true)
        setError(null)

        try {
            const token = await getAccessTokenSilently()
            const result = await IntegrationsService.deleteIntegrationsGoogle(token, accountId, tokenId)

            fetchData()
            setLoading(false)
            setConfirmModal(false)
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
            setConfirmModal(false)
        }
    }

    const handleFacebookAccountRemove = async () => {
        setLoading(true)
        setError(null)

        try {
            const token = await getAccessTokenSilently()
            const result = await IntegrationsService.deleteIntegrationsFacebook(token, accountId, integrationId)

            fetchData()
            setLoading(false)
            setFacebookRemoveModal(false)
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
        }
    }

    const handleAccountRemove = async () => {
        setLoading(true)
        setError(null)

        try {
            const token = await getAccessTokenSilently()
            const result = await IntegrationsService.deleteIntegrations(token, accountId, integrationId)

            fetchData()
            setLoading(false)
            setRemoveModal(false)
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
        }
    }

    const fetchData = async () => {
        setLoading(true)
        setError(null)

        try {
            const token = await getAccessTokenSilently()
            const googleResult = await IntegrationsService.getIntegrations(token, accountId)
            const facebookResult = await IntegrationsService.getIntegrationsFacebook(token, accountId)

            setIntegrations(googleResult)
            setFacebookIntegrations(groupBy(facebookResult, 'access_token'))
            setLoading(false)
        } catch (e) {
            logError(e)
            setLoading(false)
            setError(e.message)
        }
    }

    const handleWindowMessageFromPopup = async (event) => {
        // Don't do anything with origins that match ours
        if (event.origin == window.location.origin) return

        const { tokenId, success, status, email } = event.data

        setLoading(false)
        setError(null)
        setTokenId(tokenId == 'null' ? null : tokenId)
        setStatus(status)
        setEmail(email)

        closePopupWindow()

        if (success) setSettingsModal(true)
        if (!success) setError(ERROR.INTEGRATIONS.GOOGLE_AUTH_FAILED)
    }

    const handleGoogleLogoClick = () => {
        handlePopupWindowOpen()
    }

    const sortByAccessToken = (a: any, b: any) => {
        return a[0] ? (a[0].access_token ? a[0].access_token.localeCompare(b[0].access_token) : false) : false
    }

    const sortByName = (a: any, b: any) => {
        return a.descriptive_name ? a.descriptive_name.localeCompare(b.descriptive_name) : false
    }

    useEffect(() => {
        // If the auth window posts back a code we can handle it here
        window.addEventListener('message', handleWindowMessageFromPopup, false)

        // Make sure we remove this every time
        return () => window.removeEventListener('message', handleWindowMessageFromPopup)
    }, [])

    useEffect(() => {
        if (!accountId) return

        fetchData()
    }, [accountId])

    const healthy = integrations.filter((integration: any) => integration.api_status == INTEGRATIONS.ACTIVE)
    const unhealthy = integrations.filter((integration: any) => integration.api_status == INTEGRATIONS.INACTIVE)

    return (
        <>
            <LoaderComponent loading={loading} />
            <NotificationComponent notification={notification} error={error} />

            <View row justify="flex-end" class="mb-900">
                <Heading large>Integrations</Heading>
                <Flexer />
            </View>

            <Panel width="100%" class="mb-900">
                <Text class="cl-gray-500 t-uppercase mb-900 fw-700" small>
                    Click the button below to connect a Google Ads account
                </Text>

                <View row justify="flex-start">
                    <View class="buttonize mr-500" width="fit-content" onClick={handleGoogleLogoClick}>
                        <GoogleAdsTextLogo size={1} />
                    </View>
                    <View class="buttonize mr-500" width="fit-content" onClick={() => setFacebookSettingsModal(true)}>
                        <FacebookTextLogo size={1} />
                    </View>
                </View>
            </Panel>

            <If if={unhealthy.length != 0}>
                <Notification danger class="mb-900">
                    <NotificationText>
                        Action required: If these integrations should remain in use, please update them or remove them
                        if they are not in use.
                    </NotificationText>
                </Notification>

                <Heading class="mt-300 mb-300">Unhealthy integrations</Heading>

                <Panel width="100%">
                    {unhealthy.sort(sortByName).map((integration: any, index: number) => {
                        return (
                            <Integration
                                key={index}
                                googleAccount={integration.google_email}
                                name={integration.descriptive_name}
                                id={integration.account_id}
                                customerId={integration.client_customer_id}
                                createdAt={integration.created_at}
                                timezone={integration.time_zone}
                                currency={integration.currency_code}
                                email={integration.created_by_email}
                                status={integration.api_status}
                                statusMessage={integration.api_status_message}
                                updatedAt={integration.api_status_updated_at}
                                onUpdate={handlePopupWindowOpen}
                                onRemove={() => {
                                    setIntegrationId(integration.id)
                                    setRemoveModal(true)
                                }}
                            />
                        )
                    })}
                </Panel>
            </If>

            <If if={healthy.length != 0}>
                <Heading class="mt-900 mb-300">Connected integrations</Heading>

                <If if={healthy.length != 0}>
                    <Panel width="100%">
                        {healthy.sort(sortByName).map((integration: any, index: number) => {
                            return (
                                <Integration
                                    key={index}
                                    googleAccount={integration.google_email}
                                    name={integration.descriptive_name}
                                    id={integration.account_id}
                                    customerId={integration.client_customer_id}
                                    createdAt={integration.created_at}
                                    timezone={integration.time_zone}
                                    currency={integration.currency_code}
                                    email={integration.created_by_email}
                                    status={integration.api_status}
                                    statusMessage={integration.api_status_message}
                                    updatedAt={integration.api_status_updated_at}
                                    onUpdate={handlePopupWindowOpen}
                                    onRemove={() => {
                                        setIntegrationId(integration.id)
                                        setRemoveModal(true)
                                    }}
                                />
                            )
                        })}
                    </Panel>
                </If>
            </If>

            <If if={facebookIntegrations.length != 0}>
                <Heading class="mt-900 mb-300">Facebook Integrations</Heading>

                <If if={facebookIntegrations.length != 0}>
                    <Panel width="100%">
                        {facebookIntegrations.sort(sortByAccessToken).map((accessToken: any, index1: number) => {
                            return (
                                <View row key={index1} justify="flex-start" class="mt-600 mb-600">
                                    <View width={60}>
                                        <FacebookIconLogo size={1} />
                                    </View>
                                    <View flex={2} class="pl-800">
                                        <Heading small>Access Token</Heading>
                                        <View>
                                            <Text style={{ wordBreak: 'break-word' }}>
                                                {accessToken[0].access_token}
                                            </Text>
                                        </View>

                                        {accessToken.map((pixelId: any, index2: number) => (
                                            <FacebookIntegrationPixelId
                                                key={index2}
                                                pixelId={pixelId.pixel_id}
                                                onDelete={() => {
                                                    setIntegrationId(pixelId.id)
                                                    setFacebookRemoveModal(true)
                                                }}
                                            />
                                        ))}
                                    </View>
                                </View>
                            )
                        })}
                    </Panel>
                </If>
            </If>

            <If if={facebookSettingsModal}>
                <FacebookSettings
                    accountId={accountId}
                    onDismiss={() => setFacebookSettingsModal(false)}
                    onSave={() => {
                        setFacebookSettingsModal(false)
                        fetchData()
                    }}
                />
            </If>

            <If if={settingsModal}>
                <Settings
                    accountId={accountId}
                    tokenId={tokenId}
                    onDismiss={() => setSettingsModal(false)}
                    onSave={() => {
                        setSettingsModal(false)
                        fetchData()
                    }}
                    onError={(error) => {
                        setSettingsModal(false)
                        setStatus(error.message)
                    }}
                />
            </If>

            <Confirm
                visible={removeFacebookModal}
                title="Are you sure?"
                description="You are about to remove this Facebook pixel ID & access token combination. Are you sure?"
                onConfirm={handleFacebookAccountRemove}
                onDismiss={() => setFacebookRemoveModal(false)}
            />

            <Confirm
                visible={removeModal}
                title="Are you sure?"
                description="You are about to remove this integration. Are you sure?"
                onConfirm={handleAccountRemove}
                onDismiss={() => setRemoveModal(false)}
            />

            <Confirm
                visible={confirmModal}
                title="Are you sure?"
                description="You are about to disconnect your Google account from Adtriba. Are you sure?"
                onConfirm={deleteIntegrationsGoogle}
                onDismiss={() => setConfirmModal(false)}
            />

            <If if={!!status}>
                <Modal
                    width="60%"
                    icon="copy"
                    height="60%"
                    position={POSITION.CENTER}
                    borderRadius={20}
                    onDismiss={() => setStatus(null)}
                    footer={
                        <View row justify="flex-end">
                            <Flexer />
                            <Button onClick={() => setStatus(null)}>
                                <ButtonText>Okay</ButtonText>
                            </Button>
                        </View>
                    }
                >
                    <View width="100%" height="100%">
                        <ScrollView>
                            <View class="p-900">
                                <If if={!!status}>
                                    <Heading class="mb-300">{status}</Heading>
                                    <If if={status == INTEGRATIONS.FAILURES.REDIRECT_FAILED}>
                                        <Text class="mb-500">We experienced a redirect error from Google.</Text>
                                    </If>
                                    <If if={status == INTEGRATIONS.FAILURES.REFRESH_TOKEN_CONSENT}>
                                        <Text class="mb-500">Please disconnect your Google & Adtriba account.</Text>
                                    </If>
                                    <If if={status == INTEGRATIONS.FAILURES.NO_TOKEN_GENERATED}>
                                        <Text class="mb-500">Please disconnect your Google & Adtriba account.</Text>
                                    </If>
                                    <If if={status == INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                        <Text class="mb-500">
                                            We were not able to load your ad accounts from Google.
                                        </Text>
                                    </If>
                                    <View class="bdr-top bdr-cl-gray-300 mb-500" />
                                </If>
                                <If if={status != INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                    <Text class="mb-500">
                                        The Adtriba Dashboard is unable to access your Google account{' '}
                                        <strong>{email}</strong> and all corresponding Google Ads accounts.
                                    </Text>
                                </If>
                                <Text class="mb-500">
                                    <If if={!!tokenId && status != INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                        The below steps will disconnect your Google account from the Adtriba dashboard,
                                        take you through the process in order to revoke access to your Google account
                                        from the Adtriba dashboard and is going to reset all connected Google Ads
                                        accounts.
                                    </If>
                                    <If if={!tokenId && status != INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                        The below steps will take you through the process of revoking access to your
                                        Google account from the Adtriba dashboard, and is going to reset all connected
                                        Google Ads accounts.
                                    </If>
                                </Text>
                                <If if={status != INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                    <Text class="mb-500">
                                        After following these steps you can re-connect your Google account & add your
                                        previous Google Ads accounts.
                                    </Text>
                                </If>
                                <Heading class="mb-500">Required actions:</Heading>
                                <If if={status === INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                    <View class="pl-500">
                                        <ol>
                                            <li>
                                                <View row class="mb-500" justify="flex-start">
                                                    <Text class="mr-200">
                                                        Close this window and try again to attach your google ad
                                                        accounts.
                                                    </Text>
                                                </View>
                                            </li>
                                            <li>
                                                <View row class="mb-500" justify="flex-start">
                                                    <Text class="mr-200">
                                                        In case this error repeats itself, please contact{' '}
                                                        <a href="mailto:support@adtriba.com">support@adtriba.com</a>.
                                                    </Text>
                                                </View>
                                            </li>
                                        </ol>
                                    </View>
                                </If>
                                <If if={status != INTEGRATIONS.FAILURES.GENERAL_EXCEPTION}>
                                    <View class="pl-500">
                                        <ol>
                                            <If if={!!tokenId || status == INTEGRATIONS.FAILURES.REFRESH_TOKEN_CONSENT}>
                                                <li>
                                                    <View row class="mb-500" justify="flex-start">
                                                        <Text class="mr-200">
                                                            Disconnect the linked Google account {email} from the
                                                            Adtriba dashboard{' '}
                                                        </Text>
                                                        <Button
                                                            small
                                                            light
                                                            onClick={() => {
                                                                setConfirmModal(true)
                                                                setStatus(null)
                                                            }}
                                                        >
                                                            <ButtonText>Disconnect</ButtonText>
                                                        </Button>
                                                    </View>
                                                </li>
                                            </If>
                                            <li>
                                                <Text class="mb-500">
                                                    Revoke access for Adtriba following the steps described in{' '}
                                                    <a
                                                        href="https://help.adtriba.com/en/articles/4510701-reconnecting-your-google-ads-account-to-adtriba"
                                                        target="_blank"
                                                    >
                                                        Reconnecting your Google Ads account to Adtriba
                                                    </a>
                                                </Text>
                                            </li>
                                            <li>
                                                <Text class="mb-500">
                                                    Please follow the steps described in the{' '}
                                                    <a
                                                        href="https://help.adtriba.com/en/articles/4488739-connect-your-google-ads-account"
                                                        target="_blank"
                                                    >
                                                        Connect your Google Ads account
                                                    </a>{' '}
                                                    guide.
                                                </Text>
                                            </li>
                                            <li>
                                                <Text class="mb-500">Done.</Text>
                                            </li>
                                        </ol>
                                    </View>
                                </If>
                            </View>
                        </ScrollView>
                    </View>
                </Modal>
            </If>
        </>
    )
}
